import { getRequest }         from '@helpers/javascript/javascript'
import { addNoticeAction }    from '@redux/notices/actions'
import { workordersIndexUrl } from '@redux/workorders/actions/fetch'

// Dispatch
export const fetchPageWorkordersAction = filters => (dispatch, getState) => {
  const url = workordersIndexUrl(filters, getState().advancedFilters, 'json')

  dispatch(fetchPageWorkordersBegin())
  getRequest(url)
  .then (data  => data?.workorders
    ? dispatch(fetchPageWorkordersSuccess(data))
    : dispatch(fetchPageWorkordersFailure()))
  // Without this catch a rejected request leaves `loadingNext` stuck on true and
  // the pagination spinner never stops. Reset it and tell the user to retry.
  .catch(error => {
    dispatch(fetchPageWorkordersFailure())
    if (error?.message?.includes('Load failed')) {
      dispatch(addNoticeAction({
        message: I18n.t('mobile.list.workorders.load_failed'),
        type:    'error'
      }))
    }
  })
}

// Actions
const fetchPageWorkordersBegin = () => ({
  type: WORKORDER_FETCH_PAGE.BEGIN,
})

const fetchPageWorkordersSuccess = workorders => ({
  type: WORKORDER_FETCH_PAGE.SUCCESS,
  payload: { ...workorders }
})

const fetchPageWorkordersFailure = () => ({
  type: WORKORDER_FETCH_PAGE.FAILURE,
})

// Reducer response
export const WORKORDER_FETCH_PAGE = {
  BEGIN:   'FETCH_PAGE_WORKORDERS_BEGIN',
  SUCCESS: 'FETCH_PAGE_WORKORDERS_SUCCESS',
  FAILURE: 'FETCH_PAGE_WORKORDERS_FAILURE',

  beginResponse:   ({ state } = {}) => ({ ...state, loadingNext: true }),
  failureResponse: ({ state } = {}) => ({ ...state, loadingNext: false }),

  successResponse: ({ state, workorders, total_entries, total_pages } = {}) => {
    // Dedupe by id: re-mounting the list (e.g. returning from a card) can refetch
    // an already-loaded page, which would otherwise append duplicates.
    const existingIds = new Set(state.items.map(item => String(item.id)))
    const newItems    = (workorders || []).filter(item => !existingIds.has(String(item.id)))

    return {
      ...state,
      total_entries,
      total_pages,
      loadingNext: false,
      items: [ ...state.items, ...newItems ]
    }
  }
}
